import React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { ModalProvider } from '~/components/shared/Modal/ModalProvider';
import { setupStore } from '~/store';
import { history } from '~/constants';
import IntlProviderHOC from './components/hoc/IntlProviderHOC';
import Main from './Main';
import PostHogProvider from '~/contexts/PostHogProvider/PostHogProvider';
import './react-pdf';
import {
  ComponentsLibraryProvider,
  ModalsProvider,
} from '@qred/components-library';
import { QitUiProvider } from '@qred/qit-ui';
import '~/config/sentry'; // Import Sentry configuration
import '~/mswDev';
import ValidationContextProvider from './components/hoc/withValidation';
import { AuthProvider } from './contexts/AuthContext/AuthProvider';
import { UserProvider } from './contexts/UserContext/UserProvider';

const EnhancedIntlProvider = IntlProviderHOC(IntlProvider);
const store = setupStore();

const App = () => {
  return (
    <Provider store={store}>
      <ValidationContextProvider>
        <PostHogProvider>
          <AuthProvider>
            <UserProvider>
              <EnhancedIntlProvider>
                <QitUiProvider>
                  <ComponentsLibraryProvider>
                    <ModalsProvider>
                      <ModalProvider>
                        <Router history={history}>
                          <Main />
                        </Router>
                      </ModalProvider>
                    </ModalsProvider>
                  </ComponentsLibraryProvider>
                </QitUiProvider>
              </EnhancedIntlProvider>
            </UserProvider>
          </AuthProvider>
        </PostHogProvider>
      </ValidationContextProvider>
    </Provider>
  );
};

export default App;
